import map from './map';
import address from './address';
import cities from './cities';

export default {map, address, cities}